var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpinSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.94049 2.14881L5.06889 3.81823C3.82531 4.95124 3.03123 6.49411 2.83192 8.16459C2.63261 9.83506 3.0414 11.5214 3.9835 12.9152C4.92559 14.309 6.33802 15.317 7.96237 15.7549C9.58672 16.1927 11.3144 16.031 12.8293 15.2995L13.9583 16.9697C11.9977 17.9974 9.7271 18.2665 7.58056 17.7257C5.43401 17.1849 3.56203 15.872 2.3224 14.038C1.08277 12.204 0.562428 9.97757 0.860823 7.78414C1.15922 5.59071 2.25542 3.58416 3.93993 2.14798L3.94049 2.14881ZM5.59748 1.02882C7.55811 0.00115598 9.82868 -0.267977 11.9752 0.272855C14.1218 0.813686 15.9938 2.12655 17.2334 3.96053C18.473 5.79451 18.9934 8.02098 18.695 10.2144C18.3966 12.4078 17.3004 14.4144 15.6159 15.8506L14.4869 14.1803C15.7315 13.0475 16.5264 11.5044 16.7262 9.83335C16.926 8.16233 16.5173 6.47525 15.5749 5.08096C14.6324 3.68668 13.2193 2.67846 11.5943 2.2409C9.96927 1.80333 8.24099 1.96568 6.72587 2.69823L5.59748 1.02882Z",
    fill: "url(#paint0_linear_12251_121396)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12251_121396",
    x1: 17.2331,
    y1: 3.96012,
    x2: 2.32268,
    y2: 14.0384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7EBAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46FF9B"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinSearch);
export default __webpack_public_path__ + "static/media/spin-search.21e3d573922d8c0536d72b3e2a1f6627.svg";
export { ForwardRef as ReactComponent };